import { useEffect, useState, type FC } from 'react';
import { FeatureFlags, Modal, Stack, TextInput } from '@carbon/react';
import { ROTULOS } from './rotulos';

// A CONFIRMAÇÃO DE UMA AÇÃO DESTRUTIVA — o modal de perigo do Carbon: o rótulo diz de onde veio, o
// título pergunta, o texto diz o que acontece (e se dá para desfazer), o botão vermelho diz a ação
// com o verbo e o outro diz o que fica ("Manter conta"), para os dois nunca dizerem "Cancelar".
//
// Exclusão de alto impacto (a conta inteira) pede que a pessoa digite o nome do que apaga: com
// `digitar`, o botão vermelho só acende quando o texto confere. Enquanto a ação corre, o rodapé
// mostra o carregando do próprio Modal.
//
// A flag da v12 tira as duas "Focus sentinel" (em inglês) que o Modal do Carbon v11 põe em volta
// do diálogo: o Tab continua preso dentro dele, sem as paradas invisíveis lidas em inglês.

export const ConfirmarPerigo: FC<{
  aberto: boolean;
  rotulo?: string;
  titulo: string;
  texto: string;
  acao: string;
  /** O que o botão secundário mantém ("Manter conta", "Manter assinatura"). */
  manter: string;
  /** Exclusão de alto impacto: o que a pessoa precisa digitar para confirmar. */
  digitar?: { rotulo: string; valor: string };
  emCurso?: boolean;
  aoConfirmar: () => void;
  aoFechar: () => void;
  /** Para onde o foco volta ao fechar (o botão que abriu, quando ele não é o de antes do modal). */
  devolverFocoPara?: React.RefObject<HTMLElement | null>;
  /** Falso para uma confirmação que não destrói nada, mas não se desfaz (um envio para todos). */
  perigo?: boolean;
}> = ({ aberto, rotulo, titulo, texto, acao, manter, digitar, emCurso, aoConfirmar, aoFechar, devolverFocoPara, perigo = true }) => {
  const [digitado, setDigitado] = useState('');
  useEffect(() => { if (!aberto) setDigitado(''); }, [aberto]);
  const confere = !digitar || digitado.trim().toLowerCase() === digitar.valor.trim().toLowerCase();

  return (
    <FeatureFlags enableFocusWrapWithoutSentinels>
    <Modal
      open={aberto}
      danger={perigo}
      size='sm'
      modalLabel={rotulo}
      modalHeading={titulo}
      primaryButtonText={acao}
      secondaryButtonText={manter}
      primaryButtonDisabled={!confere}
      loadingStatus={emCurso ? 'active' : 'inactive'}
      loadingDescription='Um momento…'
      onRequestSubmit={() => { if (confere) aoConfirmar(); }}
      onRequestClose={aoFechar}
      closeButtonLabel={ROTULOS.fechar}
      launcherButtonRef={devolverFocoPara}
    >
      <Stack gap={5}>
        <p>{texto}</p>
        {digitar && (
          <TextInput
            id='confirmar-perigo-texto'
            labelText={digitar.rotulo}
            value={digitado}
            onChange={(e) => setDigitado(e.target.value)}
            autoComplete='off'
            data-modal-primary-focus
          />
        )}
      </Stack>
    </Modal>
    </FeatureFlags>
  );
};
